import React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { TextField, Button, Typography } from "@mui/material";
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle
} from "@mui/material";
import axios from "axios";
import { Subject } from "rxjs";
import { FormPane } from "../../components/FormZero/PageComponents/FormPane/FormPane";
import { ActionPanel } from "../../components/FormZero/ActionPanel/ActionPanel";
import { Button as JButton } from "../../components/FormZero/Button/Button";
import * as Material from "@mui/material";
import { IApplication } from "../../interfaces/IApplication";
import { setPageTitle } from "../../slices/applicationSlice";
import { useAppDispatch } from "../../hooks";
import { useEffect } from "react";


function AddCustomerLocationModalControl(props: { updateUI: any; }) {
    const { updateUI } = props;

    const [show, setShow] = React.useState(false);
    const formStructure = [
        { key: "name", size: { default: 12 }, type: "text", label: "Customer Name" },
        { key: "city", size: { default: 12 }, type: "text", label: "City" },
        { key: "state", size: { default: 12 }, type: "text", label: "State" },
        { key: "trayFreightCost", size: { default: 12 }, type: "text", label: "Tray Freight Cost" },
    ]

    const createRoute = async function () {
        try {
            const resp = await axios.post(`${process.env.REACT_APP_ENDPOINT}/api/CustomerLocations`, formValues);
            if (resp.status === 200) {
                await updateUI();
                setShow(false);
                formSubject.next({});
            } else {
                // TODO show error
            }
        } catch (e) {
            console.log(e);
        }
    };

    const [formValues, setFormValue] = React.useState({});

    const formSubject = new Subject();
    formSubject.subscribe((v: any) => {
        let data = { ...formValues, ...v };
        setFormValue(data);
    });

    return (
        <>
            <JButton fullWidth={true} className="button-square" clickHandler={() => setShow(true)}
                text={"Add Customer Location"} />
            {(show) && (
                <Dialog
                    open={true}
                    onClose={() => setShow(false)}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title" style={{ textAlign: "center" }}>
                        Add Customer
                    </DialogTitle>
                    <DialogContent style={{ width: '300px' }}>
                        {/*<pre>{JSON.stringify(formValues, undefined, 4)}</pre>*/}
                        <FormPane style={{ width: '100%' }} formStructure={formStructure} formSubject={formSubject}
                            initialFormData={formValues} />
                    </DialogContent>
                    <DialogActions>
                        <div style={{ display: 'flex', width: '100%', gap: '0.5rem' }}>
                            <div style={{ flexGrow: 1 }}>
                                <JButton onClick={() => setShow(false)} autoFocus text={"Close"} fullWidth={true} />
                            </div>
                            <div style={{ flexGrow: 1 }}>
                                <JButton color={'secondary'} onClick={() => createRoute().then()} autoFocus text={"Add"}
                                    fullWidth={true} />
                            </div>
                        </div>
                    </DialogActions>
                </Dialog>

            )}
        </>
    )
}

function PanelView(props: { updateUI: any; }) {
    const { updateUI } = props;
    return (
        <>
            <div className="">
                <div className="row">
                    <div className="col-6">
                        <AddCustomerLocationModalControl updateUI={updateUI} />
                    </div>
                    <div className="col-6">

                    </div>
                </div>

            </div>
        </>
    )
}

export function InvoiceSettings(props: any) {

    const dispatch = useAppDispatch();

    useEffect(() => {

        let appState: IApplication = {
            pageTitle: "Invoicing Settings",
            backgroundPath: "../assets/images/spaceallocationnbg.jpg"
        }
        dispatch(setPageTitle(appState));
    }, []);


    const { } = props;

    const [rows, setRows] = React.useState<any>([]);

    const loadLocations = async () => {
        try {
            const result = await axios.get(`${process.env.REACT_APP_ENDPOINT}/api/CustomerLocations`);
            console.log(result);
            setRows(result.data);
        }
        catch (e) {
            console.log(e);
        }
    }
    React.useEffect(() => {
        loadLocations().then()
    }, []);

    const [boxCharge, setBoxCharge] = React.useState<any>(-1);
    const loadBoxPrice = async () => {
        try { //box_price
            const result = await axios.get(`${process.env.REACT_APP_ENDPOINT}/api/Settings/Box_Price`);
            console.log(result);
            if (result.data !== undefined && result.data !== null && result.data !== "") {

                if (result.data.length === 1 && result.data[0] === null) {
                    setBoxCharge(-1);
                } else {
                    setBoxCharge(result.data[0].value);
                }
            }
            else {
                setBoxCharge(-1);
            }
        }
        catch (e) {
            console.log(e);
        }
    }
    React.useEffect(() => {
        loadBoxPrice().then()
    }, []);
    const saveBoxCharge = async function () {
        try {
            //get the current box price


            const resp = await axios.put(`${process.env.REACT_APP_ENDPOINT}/api/Settings`, {
                field: 'box_price',
                value: boxCharge
            });
            if (resp.status === 200) {
                loadBoxPrice().then()
            } else {
                // TODO show error
            }
        } catch (e) {
            console.log(e);
        }
    };

    const [columnsUnassigned, setColumnsUnassigned] = React.useState([
        { field: 'id', headerName: 'ID', width: 100, editable: false },
        { field: 'customerName', headerName: 'Customer Name', width: 300, editable: false },
        { field: 'trayFreightCost', headerName: 'Price Per Tray', width: 190, editable: true },
    ]);

    const [columns, setColumns] = React.useState([
        { field: 'id', headerName: 'ID', width: 100, editable: false },
        { field: 'CustomerName', headerName: 'Customer Name', width: 300, editable: false },
        { field: 'tray_freight_cost', headerName: 'Price Per Tray', width: 190, editable: true },
        {
            field: 'inactive', headerName: ' ', width: 150, renderCell: (cellValues: { row: { [x: string]: any; id: any; }; }) => {
                return (<Button fullWidth={true} variant={"contained"} color={(cellValues.row['inactive'] === 1) ? "success" : "warning"} onClick={() => {
                    onCellEditCommit({
                        id: cellValues.row.id,
                        field: "inactive",
                        value: !(cellValues.row['inactive'] === 1)
                    }).then(r => { });
                }}>{cellValues.row['inactive'] ? "Reactivate" : "Deactivate"}</Button>);
            }
        },
    ]);

    const onCellEditCommit = async (cellEdit: { id: any; field: any; value: any; }) => {
        console.log(cellEdit);
        let data = { field: cellEdit.field, value: cellEdit.value };
        const resp = await axios.put(
            `${process.env.REACT_APP_ENDPOINT}/api/CustomerLocations/${cellEdit.id}`,
            data
        );
        await loadLocations();
        console.log(resp);
    }


    const [expanded, setExpanded] = React.useState<any>(null);
    const panel = (<PanelView updateUI={loadLocations} />);

    const [showWithDeactivatedCustomers, setShowWithDeactivatedCustomers] = React.useState(false);

    return (
        <>
            <div style={{ margin: '1rem' }}>
                <Accordion expanded={expanded === 'panel1'} onChange={() => setExpanded(expanded === 'panel1' ? undefined : 'panel1')}>
                    <AccordionSummary
                        // expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1bh-content"
                        id="panel1bh-header"
                    >
                        <Typography sx={{ width: '33%', flexShrink: 0 }}>
                            Box Price
                        </Typography>
                        <Typography sx={{ color: 'text.secondary' }}>Set the box price here.</Typography>
                    </AccordionSummary>
                    <AccordionDetails style={{ maxHeight: "500px" }}>
                        <div style={{ width: '100%' }}>
                            {/*{JSON.stringify(boxCharge)}*/}
                            <TextField
                                autoFocus
                                margin="dense"
                                id="temperature"
                                label="Box Charge"
                                type="number"
                                fullWidth
                                value={boxCharge}
                                onChange={(e) => setBoxCharge(e.target.value)}
                                variant="outlined"
                            />
                            <br />
                            <Button fullWidth={true} variant={"contained"} color={"secondary"} onClick={() => saveBoxCharge()}>Save</Button>
                        </div>
                    </AccordionDetails>
                </Accordion>
                <Accordion expanded={expanded === 'panel3'} onChange={() => setExpanded(expanded === 'panel3' ? undefined : 'panel3')}>
                    <AccordionSummary
                        // expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1bh-content"
                        id="panel1bh-header"
                    >
                        <Typography sx={{ width: '33%', flexShrink: 0 }}>
                            Unassigned Customer Tray Prices
                        </Typography>
                        <Typography sx={{ color: 'text.secondary' }}>Set the tray price for each customer here.</Typography>
                    </AccordionSummary>
                    <AccordionDetails style={{ height: "500px" }}>
                        <DataGrid
                            rows={rows.filter((r: any) => r.tray_freight_cost === null || r.tray_freight_cost === undefined)}
                            columns={columnsUnassigned}
                            pageSize={10}
                            rowsPerPageOptions={[10]}
                            checkboxSelection={false}
                            disableSelectionOnClick={true}
                            onCellEditCommit={onCellEditCommit}
                        />
                    </AccordionDetails>
                </Accordion>
                <Accordion expanded={expanded === 'panel2'} onChange={() => setExpanded(expanded === 'panel2' ? undefined : 'panel2')}>
                    <AccordionSummary
                        // expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1bh-content"
                        id="panel1bh-header"
                    >
                        <Typography sx={{ width: '33%', flexShrink: 0 }}>
                            Customer Tray Prices
                        </Typography>
                        <Typography sx={{ color: 'text.secondary' }}>Set the tray price for each customer here.</Typography>
                    </AccordionSummary>
                    <AccordionDetails style={{ height: "500px", flexDirection: 'column', gap: '1rem' }}>
                        {/*<pre>{JSON.stringify(rows, undefined, 4)}</pre>*/}
                        <Material.Button
                            variant={"outlined"}
                            fullWidth={true}
                            style={{
                                display: "block",
                                height: `56px`,
                                textAlign: "left",
                                lineHeight: `24.5px`,
                                paddingTop: `6px`
                            }}

                            disableElevation
                            onClick={(evt) => {
                                setShowWithDeactivatedCustomers(!showWithDeactivatedCustomers);
                            }}
                        ><Material.Checkbox
                                disabled={true}
                                checked={showWithDeactivatedCustomers}
                            />&nbsp;Show With Deactivated Customers</Material.Button>
                        <DataGrid
                            rows={rows.filter((r: any) => {
                                let v = showWithDeactivatedCustomers ? 1 : 0;
                                let s = true;
                                if (!showWithDeactivatedCustomers) {
                                    s = r.inactive === v;
                                }
                                return r.tray_freight_cost !== null && r.tray_freight_cost !== undefined && s;
                            })}
                            columns={columns}
                            pageSize={10}
                            rowsPerPageOptions={[10]}
                            checkboxSelection={false}
                            disableSelectionOnClick={true}
                            onCellEditCommit={onCellEditCommit}
                        />
                    </AccordionDetails>
                </Accordion>
            </div>
            <ActionPanel Body={panel} />
        </>
    )
}
